// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/accounting/expenses/accounts-payable-ageing-report',
        component: () =>
            import('@/pages/[organisation]/accounting/expenses/accounts-payable-ageing-report.vue'),
        name: 'reports.expenses.search-accounts-payable-ageings',
        meta: {
            loginRequired: true,
            permission: 'access.reports.payables.create-accounts-payable-ageing-report',
        },
    },
];
